export const GDRIVE_CF_URL = process.env.NODE_ENV === "development" ? `http://${process.env.NEXT_PUBLIC_HOST || "localhost"}:5005/` : "https://gdrive.up.railway.app/";
